import React from 'react';
import PropTypes from 'prop-types';

const SofaNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={color}
      d="M20.406 9.825h-.159v-.08C20.247 7.673 18.574 6 16.582 6H7.418C5.426 6 3.753 7.673 3.753 9.745v.16h-.16C2.718 9.904 2 10.62 2 11.497v3.426c0 1.036.717 1.833 1.673 1.992v1.435c0 .159.16.318.319.318.16 0 .319-.159.319-.318v-1.435h15.378v1.435c0 .159.16.318.319.318.16 0 .319-.159.319-.318v-1.435A1.983 1.983 0 0 0 22 14.924v-3.506c0-.876-.717-1.593-1.594-1.593Zm-.717-.08v.319c-.478.239-.876.797-.876 1.354v.877a.545.545 0 0 1-.558.558h-6.454V6.558h4.78c1.754 0 3.108 1.434 3.108 3.187Zm-15.299 0c0-1.753 1.355-3.108 3.028-3.108h3.905v6.216H5.745a.545.545 0 0 1-.558-.558v-.877c0-.637-.318-1.115-.876-1.354v-.319h.08Zm17.052 5.1c0 .796-.637 1.434-1.354 1.434H4.15c-.796 0-1.354-.638-1.354-1.434v-3.427c0-.557.398-.956.956-.956.558 0 .956.478.956.956v.877a1.09 1.09 0 0 0 1.116 1.115h12.59a1.09 1.09 0 0 0 1.115-1.115v-.877c0-.557.398-.956.956-.956.558 0 .956.478.956.956v3.427Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

SofaNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default SofaNot;
